<template>
  <a-tooltip placement="top" arrowPointAtCenter>
    <div class="img-content" slot="title">
      <img :src="src" class="img" >
    </div>
    <img :src="src" :class="className">
  </a-tooltip>
</template>
<script>
export default {
  props: ['src', 'className']
}
</script>
<style lang="less" scoped>
.img-content {
  background-color: #fff;
}
.img {
  width: 100%;
  max-width: 200px;
}
</style>
